import React from 'react';
import { type Department } from '../lib/departments';

export interface DepartmentContextType {
  departments: Department[];
  loading: boolean;
  error: string | null;
  missingComplianceConfigurations: Department[];
}

export const DepartmentContext = React.createContext<DepartmentContextType>({
  departments: [],
  loading: true,
  error: null,
  missingComplianceConfigurations: [],
});
